module.exports = __webpack_public_path__ + "static/img/提问背景@3x.b4212b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/提问背景@3x.png
// module id = vqNB
// module chunks = 192